<!--
    description： 组织架构 - 组织管理 - 角色全新啊 - 设置用户弹窗
-->
<template>
  <IviewModal
    title="设置用户"
    @on-cancel="$emit('input', false)"
    size="middle"
    class="set-user"
    v-bind="$attrs"
    @on-ok="save"
  >
    <!-- v-on="$listeners" -->
    <div class="user-content">
      <Transfer
        :data="userList"
        :target-keys="keys"
        @on-change="handleChange1"
        filterable
        :filter-method="queryUser"
        :operations="[' 撤回用户', '选择用户 ']"
        ref="trans"
        :render-format="renderLabel"
      ></Transfer>
      <IviewTreeSelect v-model="depSearch1" :data="depTree" @select="depSelect1" class="filter-dep1"></IviewTreeSelect>
      <IviewTreeSelect v-model="depSearch2" :data="depTree" @select="depSelect2" class="filter-dep2"></IviewTreeSelect>
      <!-- <u class="filter-dep1" @click="filterDep">筛选部门</u> -->
      <!-- <u class="filter-dep2" @click="filterDep">筛选部门</u> -->
    </div>
  </IviewModal>
</template>

<script>
import Tip from './modules/Tip.vue'
import { getHtml } from '@/utils'
import { getUserInfo } from '@/utils/common'
export default {
  name: 'setUser',
  props: {
    confObj: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      userList: [],
      keys: [],
      depTree: [], //当前组织部门树
      depSearch1: '',
      depSearch2: '',
      // config: {}
    }
  },
  watch: {
    config: {
      handler(n) {
        if (n?.groupId) {
          n && this.getDepTree(n)
        }
      },
      deep: true
    }
  },
  updated() {},
  computed: {
    config() {
      return this.$parent.config || this.confObj
    }
  },
  mounted() {
    // this.$bus.$on('getRoleUset', (params) => {
    //   this.$api.role.getRoleUser({}, params).then(({ data }) => {
    //     this.keys = data.records.map((item) => item.id)
    //   })
    // })
    // this.config = this.$parent.config
    // 过滤出当前归属组织
    // this.$api.role.getDepTree({}, [this.config?.groupId]).then((res) => {
    //   this.depTree = [res.data]
    // })
    this.getDepTree(this.config?.groupId);
    // this.depTree= this.config.depTree.filter((item) => item.id == this.config.groupId)
  },
  methods: {
    renderLabel(item) {
      return getHtml(Tip, { data: item }).innerHTML
    },
    // 筛选部门
    depSelect1(id) {
      this.getUser(id, (data) => {
        this.$refs.trans.leftData = data.filter((item) => !this.keys.includes(item.id))
      })
    },
    depSelect2(id) {
      this.getUser(id, (data) => {
        this.$refs.trans.rightData = data.filter((item) => this.keys.includes(item.id))
      })
    },
    handleChange1(targetKeys, direction, moveKeys) {
      this.keys = targetKeys
      this.depSearch1 = ''
      this.depSearch2 = ''
    },
    // 搜索函数
    queryUser(data, query) {
      return data.label.indexOf(query) > -1
    },
    save() {
      let keys = []
      this.keys = Array.from(new Set(this.keys))
      this.userList.map((item2) => {
        this.keys.map((item) => {
          if (item == item2.id) {
            keys.push({ id: item, displayName: item2.displayName })
          }
        })
      })
      this.$emit('confirm', { roleUserList: keys, groupUserList: this.userList})
    },
    getUser(id, callback) {
      let { orgLevel } = this.config || {}
      if ((id || this.config?.id) && orgLevel) {
        this.$api.role
          .getUser(
            {
              orgLevel,
              pageCurrent: 1,
              pageSize: -1,
              queryType: 1
            },
            [id || this.config.id]
          )
          .then(({ data }) => {
            // getWithoutUser
            let userData = data.records.map((item) => {
              return {
                ...item,
                // key: { id: item.id, displayName: item.userName },
                key: item.id,
                label: item.displayName,
                // description: item.displayName,
                disabled: false
              }
            })
            if (callback) return callback(userData)
            this.userList = userData
          })
      }
    },
    async getRoleUser(params) {
      this.userList = []
      await this.$api.role.getRoleUser({
        pageSize: 10000,
        pageCurrent: 1
      }, params).then(({ data }) => {
        this.keys = data.records.map((item) => item.id)
      })
    },
    async getDepTree(id) {
      id = await this.config?.groupId;
      let orgLevel = this.config?.orgLevel;
      if (!id) {
        let userInfo = await getUserInfo()
        id = (userInfo.currentGroup || {}).id;
        orgLevel = (userInfo.currentGroup || {}).orgLevel;
      }
      await this.$api.organ.getOrganTree2({ orgLevel }, [id]).then((res) => {
        let data = res.data.treeList;
        this.depTree = data;
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '~_c/iview/config/index';
.set-user {
  /deep/.ivu-transfer-list-content-item {
    overflow: initial;
  }
  .user-content {
    height: 100%;
    position: relative;
    width: 648px !important;
    .filter-dep1,
    .filter-dep2 {
      position: absolute;
      top: 76px;
      cursor: pointer;
      &:active,
      &:hover {
        font-weight: 600;
        color: #1a45b8;
      }
      /deep/.ivu-select-selection {
        width: 200px !important;
        height: 28px;
      }
    }
    .filter-dep1 {
      left: 52px;
    }
    .filter-dep2 {
      left: 400px;
    }
    .flex-cen();
    .ivu-transfer {
      height: 100%;
      // display: flex;
      // align-items: center;
    }

    /deep/.ivu-transfer-list {
      width: 220px;
      height: 440px;
      background: #ffffff;
      box-shadow: 0px 2px 10px 0px rgba(201, 208, 228, 0.58);
      border-radius: 4px;
      border: 1px solid #eceef0;
      position: relative;

      &.ivu-transfer-list-with-footer {
        padding-bottom: 0 !important;
      }

      .ivu-transfer-list-footer {
        height: 0;
      }

      .dep_filter {
        position: absolute;
        width: 100%;
        bottom: 310px;

        .i-select {
          width: 100%;
          height: 26px;
          padding: 0 8px;

          .ivu-select,
          .ivu-select-selection {
            width: 100%;
            height: 100%;
            .flex-center();
            justify-content: flex-start;

            input {
              height: 100%;
            }
          }
        }
      }
    }

    /* 头部标题 */
    /deep/.ivu-transfer-list-header {
      width: 100%;
      height: 38px;
      background: var(--theme-table-headBg);
      border-radius: 3px 3px 0 0;

      .ivu-transfer-list-header-title {
        font-size: 14px;
        font-weight: bold;
        color: var(--theme-color);
        line-height: 22px;
      }

      .ivu-transfer-list-header-count {
        display: none;
      }
    }

    /* 筛选框 */
    // /deep/.ivu-transfer-list-body-search-wrapper {
    // }
    /deep/.ivu-input-wrapper {
      // width: 160px;
    }
    /deep/.ivu-input {
      &:hover {
        .input-view-hover();
      }

      &:focus {
        .input-view-focus();
      }
    }

    /deep/ .ivu-transfer-list-body-with-search {
      padding-top: 70px;

      .ivu-transfer-list-content {
        height: 100%;
        .show-scroll();

        .ivu-transfer-list-content-item {
          font-size: 14px !important;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
          line-height: 22px;

          > span {
            padding-left: 0px;
          }
        }
      }
    }

    // // /* 中间transfor栏 */
    /deep/.ivu-transfer-operation {
      .ivu-btn {
        width: 95px;
        padding: 0 20px;
        height: 24px;
        background: #ffffff;
        border: 1px solid var(--theme-color);
        font-size: 12px;
        font-weight: bold;
        color: var(--theme-color);
        line-height: 22px;
        .flex-cen();
        // span {
        //   i {
        //     font-size: 12px;
        //     font-weight: bold;
        //     color: #456bd1;
        //     line-height: 22px;
        //   }
        // }
      }
    }
  }
}
</style>
